export const employeesConfigRoutes = [
  {
    path: '/employees',
    name: 'employees',
    component: () => import('./views/Employees.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
]
